import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { apiSlice } from "./slices/apiSlice";
import endpointsSlice from "./slices/endpointsSlice";
import navigationSlice from "./slices/navigationSlice";
import controlPanelSlice from "./slices/controlPanelSlice";

const rootReducer = combineReducers({
  [apiSlice.reducerPath]: apiSlice.reducer,
  endpoints: endpointsSlice,
  navigation: navigationSlice,
  controlPanelStatus: controlPanelSlice,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }).concat(apiSlice.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
